<script setup>
import { useI18n } from 'vue-i18n';
import SupplierDealReportLeaderboardRow from './SupplierDealReportLeaderboardRow.vue';
import { formatWholeNumber } from '@/utils/poolaReportFormat.js';

defineProps({
  // Ranked leaderboard rows (see useSupplierDealReport's composeLeaderboard).
  rows: { type: Array, default: () => [] },
  myRank: { type: Number, default: null },
  totalSuppliers: { type: Number, default: 0 },
  dealTitle: { type: String, default: null },
});

const { t } = useI18n({ useScope: 'global' });
</script>

<template>
  <div class="report-leaderboard" data-report-section="leaderboard">
    <div class="report-leaderboard__head">
      <h2 class="report-section-title">
        {{ t('poola.report.leaderboard.title', { deal: dealTitle }) }}
      </h2>
      <span v-if="myRank != null" class="report-leaderboard__rank">
        {{
          t('poola.report.leaderboard.rankLine', {
            n: formatWholeNumber(myRank),
            m: formatWholeNumber(totalSuppliers),
          })
        }}
      </span>
    </div>
    <div class="report-leaderboard__rows">
      <supplier-deal-report-leaderboard-row
        v-for="row in rows"
        :key="row.supplierId"
        :row="row"
      ></supplier-deal-report-leaderboard-row>
    </div>
  </div>
</template>

<style scoped>
.report-leaderboard {
  display: flex;
  flex-direction: column;
  gap: 11px;
  padding-inline: var(--poolit-spacing-md, 16px);
}

.report-section-title {
  margin: 2px 0 0;
  font-size: 15px;
  font-weight: var(--poolit-font-weight-bold, 700);
  color: var(--report-text);
}

.report-leaderboard__head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}

.report-leaderboard__rank {
  font-size: 12.5px;
  color: var(--report-text-soft);
  font-weight: var(--poolit-font-weight-semibold, 600);
  background: var(--report-surface-2);
  border-radius: var(--poolit-radius-full, 9999px);
  padding: 4px 10px;
  white-space: nowrap;
}

.report-leaderboard__rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
